import { selectors as requestSelectors } from "redux-request-state";

const modelsBase = state => state.files.models;
export const isLoadingModels = requestSelectors.isLoading( modelsBase );
export const getModels = requestSelectors.getData( modelsBase );
export const getModelsError = requestSelectors.getError( modelsBase );

const modelSectionsBase = state => state.files.modelSections;
export const getModelSections = fileModelId => state => modelSectionsBase( state )[ fileModelId ]?.data;
export const isLoadingSections = fileModelId => state => modelSectionsBase( state )[ fileModelId ]?.loading;